import { useContext } from "react";
import { Loader, Tabs, Text } from "@mantine/core";
import GiveawayForm from "../components/Giveaways/GiveawayForm";
import { useGetSponsors } from "../api/sponsors";
import { AuthContext } from "../services/context";
import { getCurrentWorkspace } from "../services/userConfig";
import { useGetEvent } from "../api/event";
import { useGetGiveawayByEventId } from "../api/giveaways";
import { useSearchParams } from "react-router-dom";
import GiveawaySponsorsForm from "../components/Giveaways/GiveawaySponsorsForm";
import {
  IconPlus,
  IconPencil,
  IconVersions,
  IconUsers,
} from "@tabler/icons-react";
import Participants from "../components/Giveaways/Participants";
import GiveawayHistory from "../components/Giveaways/GiveawayHistory";
import { useGetPages } from "../api/pages";

const Giveaway = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabValue = searchParams.get("tab") || "general";

  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);
  const {
    data: event,
    isPending,
    isError,
    error,
  } = useGetEvent(currentWorkspace.eventId);

  const { data: pages } = useGetPages({
    eventId: currentWorkspace.eventId,
    all: true,
  });

  const { data: sponsors } = useGetSponsors({
    workspaceId: currentWorkspace.id,
    eventId: currentWorkspace.eventId,
    sort: { columnAccessor: "name", direction: "asc" },
  });

  const { data: giveaway } = useGetGiveawayByEventId(event?.id);

  const handleTabChange = (tab) => {
    setSearchParams({ tab });
  };

  if (isPending) {
    return <Loader mt={10} />;
  }
  if (isError) {
    return <Text c="red">{error.message}</Text>;
  }

  return (
    <Tabs
      keepMounted={false}
      variant="outline"
      value={tabValue}
      onChange={(value) => handleTabChange(value)}
    >
      <Tabs.List>
        <Tabs.Tab
          value="general"
          leftSection={
            giveaway ? <IconPencil size={12} /> : <IconPlus size={12} />
          }
        >
          {giveaway ? "Edit" : "Create"}
        </Tabs.Tab>
        {giveaway && (
          <Tabs.Tab value="sponsors" leftSection={<IconVersions size={12} />}>
            Sponsors
          </Tabs.Tab>
        )}
        {giveaway && (
          <Tabs.Tab value="participants" leftSection={<IconUsers size={12} />}>
            Participants
          </Tabs.Tab>
        )}
        {giveaway && (
          <Tabs.Tab value="history" leftSection={<IconVersions size={12} />}>
            History
          </Tabs.Tab>
        )}
      </Tabs.List>

      <Tabs.Panel value="general">
        <GiveawayForm
          key={giveaway?.id || "create"}
          event={event}
          giveaway={giveaway}
          pages={pages}
        />
      </Tabs.Panel>
      {giveaway && (
        <Tabs.Panel value="sponsors">
          <GiveawaySponsorsForm sponsors={sponsors} giveaway={giveaway} />
        </Tabs.Panel>
      )}
      {giveaway && (
        <Tabs.Panel value="participants">
          <Participants giveaway={giveaway} sponsors={sponsors} />
        </Tabs.Panel>
      )}
      {giveaway && (
        <Tabs.Panel value="history">
          <GiveawayHistory giveawayId={giveaway.id} />
        </Tabs.Panel>
      )}
    </Tabs>
  );
};

export default Giveaway;
